module.exports = __webpack_public_path__ + "static/img/rs_js_12.e683270.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/rs/rs_js_12.png
// module id = jydi
// module chunks = 1